import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    modal_container: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        margin: 0,
        padding: 0
    },
    contacts_container: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    },
    body: {
        display: 'flex',
        padding: '8px 16px',
        flexDirection: 'column'
    },
    input: {
        marginTop: '16px'
    },
    search_btn: {
        justifySelf: 'flex-end'
    },
    all_items_container:{
        display: 'flex',
        flexDirection: 'column',
        marginTop: '16px',
        gap: '8px',
    },
    items_container: {
        border: `1px solid ${theme.palette.grey["400"]}`,
    },
    menu_container:{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'flex-start',
        "& > *": {
            marginLeft: '4px'
        }
    },
    new_btn_container: {
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-end',
    }
}));

export {useStyles}